var React = require('react');

function Instagram (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.stin0{fill-rule:evenodd;clip-rule:evenodd;}\r\n"),React.createElement("path",{"className":"stin0","d":"M25.3,3H12.7c-5.2,0-9.5,4-9.5,9v12c0,5,4.3,9,9.5,9h12.7c5.2,0,9.5-4,9.5-9V12C34.8,7,30.6,3,25.3,3z M6.3,12\r\n\tc0-3.3,2.8-6,6.3-6h12.7c3.5,0,6.3,2.7,6.3,6v12c0,3.3-2.8,6-6.3,6H12.7c-3.5,0-6.3-2.7-6.3-6V12z M19,25.5c-4.4,0-7.9-3.4-7.9-7.5\r\n\ts3.5-7.5,7.9-7.5c4.4,0,7.9,3.4,7.9,7.5S23.4,25.5,19,25.5z M19,22.5c2.6,0,4.8-2,4.8-4.5s-2.1-4.5-4.8-4.5c-2.6,0-4.8,2-4.8,4.5\r\n\tS16.4,22.5,19,22.5z M28.5,10.5c0,0.8-0.7,1.5-1.6,1.5c-0.9,0-1.6-0.7-1.6-1.5C25.3,9.7,26,9,26.9,9C27.8,9,28.5,9.7,28.5,10.5z","key":1})]);
}

Instagram.defaultProps = {"version":"1.1","id":"insta","x":"0px","y":"0px","viewBox":"0 0 38 36","style":{"enableBackground":"new 0 0 38 36"},"xmlSpace":"preserve"};

module.exports = Instagram;

Instagram.default = Instagram;
